/*
 * Do not update this file manually.
 * It is automatically generated from /scripts/generate-contentful-types.ts
 */
import type {
    ChainModifiers,
    Entry,
    EntryFieldTypes,
    EntrySkeletonType,
    LocaleCode,
} from 'contentful'
import type { TypeTdCustomPageButtonSkeleton } from './TypeTdCustomPageButton'
import type { TypeTdCustomPageRadioTileSkeleton } from './TypeTdCustomPageRadioTile'

export interface TypeTdCustomPageRadioTileContainerFields {
    name: EntryFieldTypes.Symbol
    radioTiles?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeTdCustomPageRadioTileSkeleton>>
    button?: EntryFieldTypes.EntryLink<TypeTdCustomPageButtonSkeleton>
}

export type TypeTdCustomPageRadioTileContainerSkeleton = EntrySkeletonType<
    TypeTdCustomPageRadioTileContainerFields,
    'tdCustomPageRadioTileContainer'
>
export type TypeTdCustomPageRadioTileContainer<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeTdCustomPageRadioTileContainerSkeleton, Modifiers, Locales>

export function isTypeTdCustomPageRadioTileContainer<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode,
>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTdCustomPageRadioTileContainer<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'tdCustomPageRadioTileContainer'
}
